import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Córdoba'
}, {
  name: 'Juan P.',
  city: 'Buenos Aires'
}, {
  name: 'Carla M.',
  city: 'Rosario'
}, {
  name: 'Sofía R.',
  city: 'Mendoza'
}, {
  name: 'Lucas G.',
  city: 'La Plata'
}, {
  name: 'Ana T.',
  city: 'Salta'
}, {
  name: 'Pedro S.',
  city: 'Tucumán'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(() => {
      setVisible(true);
    }, 5000);
    // Cycle popups
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
        setCurrentPurchase(randomPurchase);
        setVisible(true);
      }, 2000); // Wait 2s before showing next
    }, 15000); // Every 15s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm w-full animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-7">
      <div className="bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 relative flex items-center gap-4" data-id="element-8">
        <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-9">
          <X size={14} data-id="element-10" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-11">
          <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-12" />
        </div>

        <div data-id="element-13">
          <p className="text-sm font-bold text-gray-900" data-id="element-14">
            ¡Nueva compra realizada!
          </p>
          <p className="text-sm text-gray-600" data-id="element-15">
            <span className="font-semibold text-gray-800" data-id="element-16">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-17">hace unos instantes</p>
        </div>
      </div>
    </div>;
}